import React, {Component} from 'react'
import ReactTooltip from "react-tooltip"

import {formatNumber} from "../../utils/util"
import {getPaymentOutstandingMessageHtml} from "./HintMessage"

export class TotalChargeAndInvoiceRenderer extends Component {
  constructor(props) {
    super(props)
    this.imgRef = React.createRef()
  }

  handleHover() {
    ReactTooltip.rebuild()
    ReactTooltip.show(this.imgRef.current)
  }

  handleHoverOut() {
    ReactTooltip.hide(this.imgRef.current)
  }

  render() {
    const total = formatNumber(this.props.data.totalCharges)
    return (
        <React.Fragment>
          {this.getWarningIcon()}
          <div className="grid-container"
               style={{
                 marginLeft: 'auto',
                 gridColumnGap: '5px',
                 gridTemplateColumns: 'max-content max-content',
                 display: 'grid'
               }}>
            <div className="grid-item" style={{textAlign: 'end'}}>{total}</div>
            <div className="grid-item">{this.props.data.currency}</div>
          </div>
        </React.Fragment>
    )
  }

  getWarningIcon() {
    const paymentStatus = this.props.data.paymentStatus || ''
    if (!paymentStatus.startsWith("Not Available")) {
      return null
    }
    const isForPaymentRequested = paymentStatus.includes('Requested')
    const toolTip = isForPaymentRequested
        ? getPaymentOutstandingMessageHtml(this.props.data.lastPaymentAmount, true)
        : "Processing of last invoice and payment is in progress.<br/>A new payment request cannot be made until the processing completes.<br/>Please contact Import Customer Service if you have any questions."
    const iconSrc = isForPaymentRequested
        ? "images/icon-unpaid.svg"
        : "images/to-do-list-warning.svg"
    return <img data-tip={"<div style='font-size: 12px'>" + toolTip + "</div>"}
                data-html={true}
                data-for="n2c3-tooltip"
                ref={this.imgRef}
                data-place={"top"}
                onMouseOver={this.handleHover.bind(this)}
                onMouseOut={this.handleHoverOut.bind(this)}
                style={{position: 'absolute', zIndex: 3, left: 9, top: 11}} alt="warning"
                src={iconSrc}/>
  }
}

export default TotalChargeAndInvoiceRenderer